import { Outlet } from "react-router-dom";
import { Container } from "react-bootstrap";

const Layout = () => (
  <Container className="layout--wide">
    <Outlet />
  </Container>
);

export default Layout;
